import { render } from "./CasinoBasicDetails.vue?vue&type=template&id=3a9691b8&scoped=true"
import script from "./CasinoBasicDetails.vue?vue&type=script&lang=js"
export * from "./CasinoBasicDetails.vue?vue&type=script&lang=js"

import "./CasinoBasicDetails.vue?vue&type=style&index=0&id=3a9691b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9691b8"]])

export default __exports__